// src/services/securityUserService.js

import axiosInstance from "../config/axiosInstance";

const BASE_URL = "/securityuser";

/**
 * Obtiene la lista paginada de usuarios de seguridad.
 * @param {number} page - Número de página (inicia en 1)
 * @param {number} size - Cantidad de elementos por página
 * @returns {Promise<ApiResponse<PaginatedResult<SecurityUserDto>>>}
 */
export const getSecurityUsers = async (page = 1, size = 10) => {
  const response = await axiosInstance.get(
    `${BASE_URL}/paged?pageIndex=${page}&pageSize=${size}`
  );
  return response.data;
};

/**
 * Obtiene la lista paginada de usuarios con rol "company_admin".
 * @param {number} page - Número de página (inicia en 1)
 * @param {number} size - Cantidad de elementos por página
 * @param {string|null} searchTerm - Término de búsqueda (opcional)
 * @returns {Promise<ApiResponse<PaginatedResult<SecurityUserDto>>>}
 */
export const getCompanyAdminUsers = async (
  page = 1,
  size = 10,
  searchTerm = null
) => {
  const response = await axiosInstance.get(
    `${BASE_URL}/paged/company-admins?pageIndex=${page}&pageSize=${size}&searchTerm=${searchTerm}`
  );
  return response.data;
};

/**
 * Obtiene un usuario de seguridad por su ID.
 * @param {string} id - ID del usuario
 * @returns {Promise<ApiResponse<SecurityUserDto>>}
 */
export const getSecurityUserById = async (id) => {
  const response = await axiosInstance.get(`${BASE_URL}/${id}`);
  return response.data;
};

/**
 * Crea un nuevo usuario de seguridad.
 * @param {CreateSecurityUserDto} data - Datos del nuevo usuario
 * @returns {Promise<ApiResponse<SecurityUserDto>>}
 */
export const createSecurityUser = async (data) => {
  const response = await axiosInstance.post(BASE_URL, data);
  return response.data;
};

/**
 * Actualiza un usuario de seguridad existente.
 * @param {UpdateSecurityUserDto} data - Datos actualizados del usuario
 * @returns {Promise<ApiResponse<boolean>>}
 */
export const updateSecurityUser = async (data) => {
  const response = await axiosInstance.put(`${BASE_URL}/${data.id}`, data);
  return response.data;
};

/**
 * Elimina (soft delete) un usuario de seguridad por su ID.
 * @param {string} id - ID del usuario
 * @returns {Promise<ApiResponse<boolean>>}
 */
export const deleteSecurityUser = async (id) => {
  const response = await axiosInstance.delete(`${BASE_URL}/${id}`);
  return response.data;
};
